import React from 'react';
import { useChannelStateContext, useChatContext } from 'stream-chat-react';
import './MessagingChannelHeader.css';
import AvatarGroup from './AvatarGroup';
import { TypingIndicator } from '../components/TypingIndicator';
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import { useChannelDisplayName } from '../hooks/useChannelDisplayName';
import type { Channel } from 'stream-chat';

type Props = {
  theme: string;
  toggleMobile: () => void;
};

const SUPPORT_CHAT_AVATAR = '/assets/img/support.png';

const isSupportChannel = (channel: Channel) => {
  return channel.id === 'support-chat' || channel.data?.type === 'support';
};

const MessagingChannelHeader = (props: Props) => {
  const { theme, toggleMobile } = props;
  const { client } = useChatContext();
  const { channel } = useChannelStateContext();
  const members = Object.values(channel.state?.members ?? {}).filter(
    (member) => member?.user?.id !== client?.user?.id,
  );
  const displayName = useChannelDisplayName(channel, members);

  // Use hardcoded support avatar or pass members to AvatarGroup
  const avatarProps = isSupportChannel(channel)
    ? { image: SUPPORT_CHAT_AVATAR, members: [] }
    : { members };

  return (
    <div className='messaging__channel-header' aria-label='Chat channel header'>
      <div id='mobile-nav-icon' className={`${theme}`} onClick={() => toggleMobile()} aria-label='Toggle mobile navigation'>
        <ChevronLeftIcon className='my-auto mx-auto' size={30} color='#60b6aa' />
      </div>
      <AvatarGroup
        {...avatarProps}
      />
      <div className='channel-header__name'>{displayName}</div>
      <div className='messaging__channel-header__right'>
        <TypingIndicator />
      </div>
    </div>
  );
};

export default React.memo(MessagingChannelHeader);
